import {defineStore} from 'pinia'
import axios from "@/plugins/axios.js";
import router from "@/router";

export const useUserStore = defineStore('user', {
    state: () => ({
        userInfo: null,
        loaded: false,
        loading: false,
        userImages: {},
        fileUrl: window.appConfig.FILE_URL,
        apiBaseUrl: window.appConfig.API_URL_BASE,
        pollInterval: null,
        ban: false,
        banMsg: '',
        settings: '',
    }),

    getters: {
        getUserInfo: (state) => state.userInfo,
        getBan: (state) => {
            return {'ban': state.ban, 'msg': state.banMsg}
        },
        getSettings: (state) => {
            return state.settings
        },
    },

    actions: {
        setSettings(settings) {
            this.settings = settings
        },

        setBan(status, message = '') {
            this.ban = status
            this.banMsg = message
        },

        clearBan() {
            this.ban = false
            this.banMsg = ''
        },
        async loadImage(img) {
            if (!img) return null

            // اگر قبلا دانلود شده
            if (this.userImages[img]) {
                return this.userImages[img]
            }

            const token = localStorage.getItem('token')

            const response = await fetch(this.fileUrl + img, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            const blob = await response.blob()
            const imageUrl = URL.createObjectURL(blob)

            this.userImages[img] = imageUrl

            return imageUrl
        },

        async loadUser(token) {
            if (this.loading) return

            if (this.loaded && this.userInfo) return

            this.loading = true

            try {
                const userInfo = await this.getUser(token)

                if (!userInfo) return

                const features = await this.getLicenseFeatures(token)

                userInfo.data.features = features

                await this.getUserShift(userInfo, token)

                this.userInfo = userInfo
                this.loaded = true
                this.startPolling()
            } catch (err) {

                if (err.response?.status === 401) {
                    this.clearUser()

                    return
                }

                throw err

            } finally {
                this.loading = false
            }
        },
        startPolling() {
            this.stopPolling()

            this.pollInterval = setInterval(async () => {
                const token = localStorage.getItem('token')

                if (!token) {
                    this.clearUser()
                    if (!router.currentRoute.value.path.startsWith('/auth/')) {
                        await router.push('/auth/login')
                    }
                    return
                }

                try {

                    await this.getUser(token)
                } catch (err) {

                    if (err.response?.status === 403 || err.response?.status === 401) {
                        this.clearUser()
                    }
                }
            }, 30000)
        },

        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval)
                this.pollInterval = null
            }
        },
        async getUser(token) {
            if (!token) return
            try {
                const res = await axios.get(
                    this.apiBaseUrl + 'api/users/get-user',
                    {
                        headers: {
                            Authorization: 'Bearer ' + token,
                        },
                    }
                )

                return res?.data

            } catch (err) {
                console.log('err',err)

                if (err.response?.status === 401) {
                    this.clearUser()
                    /*  router.push('/auth/login')*/
                    return
                }

                throw err
            }

        },

        async getLicenseFeatures(token) {
            const res = await axios.get(
                this.apiBaseUrl + 'api/license/get-license-features',
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    },
                }
            )

            return res.data.features
        },

        async getUserShift(userInfo, token) {
            const activeLicenses = userInfo?.data?.features?.filter(item => item.is_active)
                .map(item => item.name)

            const formsaz = activeLicenses?.includes('formsaz')

            if (formsaz) {
                return
            }

            const res = await axios.get(
                this.apiBaseUrl + 'api/shift-users/get-user-shift',
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    },
                }
            )

            const cartables = []
            const seen = new Set()

            res.data.data.forEach(item => {
                item.cartables.forEach(cartable => {
                    if (!seen.has(cartable.value)) {
                        seen.add(cartable.value)
                        cartables.push(cartable)
                    }
                })
            })

            userInfo.data.cartables = cartables
        },

        clearUser() {
            this.stopPolling()
            this.userInfo = null
            this.loaded = false

        },
    },

})
